import { lazy } from "react";

export const OfferList = lazy(() => import("../pages/offerList"));
export const CreateOffer = lazy(() => import("../pages/offerCreate"));
export const Offer = lazy(() => import("../pages/offerView"));
export const ShippingList = lazy(() => import("../pages/shippingList"));
export const CreateShipping = lazy(() => import("../pages/shippingCreate"));
export const ViewShipping = lazy(() => import("../pages/shippingView"));
export const Users = lazy(() => import("../pages/users"));
export const Login = lazy(() => import("../pages/login"));
export const Reset = lazy(() => import("../pages/reset"));
export const Register = lazy(() => import("../pages/register"));
export const Settings = lazy(
  () => import("../pages/settings/components/content"),
);
export const SettingsLayout = lazy(() => import("../pages/settings"));
export const SettingsKeyedOutlet = lazy(
  () => import("../pages/settings/components/settingsKeyed"),
);
export const LiteWms = lazy(() => import("../pages/liteWms"));
export const LiteTms = lazy(() => import("../pages/liteTms"));
export const LiteTmsWhs = lazy(() => import("../pages/liteTmsWhs"));
export const LiteCustoms = lazy(() => import("../pages/liteCustoms"));
export const ShippingTabContent = lazy(
  () => import("../pages/shippingView/components/tabContent"),
);
export const ShippingCaseDefaultRedirect = lazy(
  () => import("../pages/shippingView/components/defaultTabRedirect"),
);

export const CustomsLayout = lazy(
  () => import("../pages/shippingView/tabs/customs"),
);
export const CustomsDefaultRedirect = lazy(
  () => import("../pages/shippingView/tabs/customs/components/defaultRedirect"),
);
export const Customs = lazy(
  () => import("../pages/shippingView/tabs/customs/components/content"),
);

export const UnloadingLayout = lazy(
  () => import("../pages/shippingView/tabs/unloading"),
);
export const UnloadingDefaultRedirect = lazy(
  () =>
    import("../pages/shippingView/tabs/unloading/components/defaultRedirect"),
);
export const Details = lazy(
  () => import("../pages/shippingView/tabs/unloading/components/details"),
);
export const Warehausing = lazy(
  () => import("../pages/shippingView/tabs/unloading/components/warehausing"),
);
export const ShiftingAccordion = lazy(
  () =>
    import("../pages/shippingView/tabs/unloading/components/shiftingAccordion"),
);
export const DepositaryAccordion = lazy(
  () =>
    import("../pages/shippingView/tabs/unloading/components/depositaryAccordion"),
);
export const PickingAccordion = lazy(
  () =>
    import("../pages/shippingView/tabs/unloading/components/pickingAccordion"),
);
export const CargoReleaseAccordion = lazy(
  () =>
    import("../pages/shippingView/tabs/unloading/components/cargoReleaseAccordion"),
);
export const CargoDetailsLayout = lazy(
  () => import("../pages/shippingView/tabs/cargoDetails"),
);
export const LoadingOrderLayout = lazy(
  () => import("../pages/shippingView/tabs/tms/components/loadingOrderList"),
);
export const LoadingOrderWhsLayout = lazy(
  () => import("../pages/shippingView/tabs/tms/components/loadingOrderWhsList"),
);
export const TMSLayoutWrapper = lazy(
  () => import("../pages/shippingView/tabs/tms"),
);
export const CommoditySheet = lazy(
  () => import("../pages/shippingView/tabs/tms/components/commoditySheet"),
);
export const LoWhsSheet = lazy(
  () => import("../pages/shippingView/tabs/tms/components/loWhs"),
);
export const Voyage = lazy(
  () => import("../pages/shippingView/tabs/cargoDetails/components/voyage"),
);
export const Commodities = lazy(
  () =>
    import("../pages/shippingView/tabs/cargoDetails/components/commodities"),
);

export const DeliveryList = lazy(() => import("../pages/deliveryList"));
export const WhsDeliveryList = lazy(() => import("../pages/whsDeliveryList"));

export const DeliveryLayout = lazy(
  () => import("../pages/shippingView/tabs/delivery"),
);
export const DeliveryDefaultRedirect = lazy(
  () =>
    import("../pages/shippingView/tabs/delivery/components/defaultRedirect"),
);
export const Delivery = lazy(
  () => import("../pages/shippingView/tabs/delivery/components/content"),
);
export const IncomeStatementLayout = lazy(
  () => import("../pages/shippingView/tabs/incomeStatement"),
);

export const IncomeStatement = lazy(
  () => import("../pages/shippingView/tabs/incomeStatement/components/content"),
);
